import { createContext } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import FormVerification from '@containers/form-verification/index';

interface FormContextType {
  profile: any;
}

/**
 * @see {@link FormVerification} to get to the Provider (of this context)
 */
const FormContext = createContext<FormContextType | undefined>(undefined);

export default FormContext;
